import { CacheableDataObject } from 'models/CacheableDataObject.jsx';
import { League } from './League';

class MatchPlayer extends CacheableDataObject {
	characterIsAvailable(character) {
		if(this.match && this.match.slot && this.match.slot.unavailable_characters) {
			return !this.match.slot.unavailable_characters[character.id];
		}
		else {
			return true;
		}
	}

	getActiveSlot() {
		if(this.match && this.match.slot) {
			return this.match.slot.number;
		}
		return 1;
	}

}

MatchPlayer.prototype.dataLocationParsers = {
	player: (matchPlayer, data) => {
		matchPlayer.player = Users.update(data.player);
	},
	match: (matchPlayer, data) => {
		matchPlayer.match = data.match;
		if(data.match.league) {
			matchPlayer.match.league = League.create(data.match.league);
		}
		if(data.match.previous_league) {
			matchPlayer.match.previous_league = League.create(data.match.previous_league);
		}
		if(data.match.highest_league) {
			matchPlayer.match.highest_league = League.create(data.match.highest_league);
		}
	},
};

export { MatchPlayer };